<template>
  <div style="width: 100%;height: 100%;">
    <div style="height: 60px;display: flex">
      <div style="height: 60px;margin-left: 20px;margin-right: 5px;">
        <el-image style="height: 100%;" src="/icon/JOYSUN.jpg"></el-image>
      </div>
      <div style="line-height: 60px;font-size: 20px;font-family:'黑体','sans-serif';">
        卓盛工具仓库
      </div>
    </div>
    <div style="height:50px;background-color:#E0F4FF;display: flex;line-height: 50px;">
      <div style="width: 100px;margin-left: 15%;text-align: right;padding-right: 5px;">软件名称</div>
      <div style="width: 10%">
        <el-input v-model="softwareName"></el-input>
      </div>
      <div style="width: 100px;text-align: right;padding-right: 5px;">软件标签</div>
      <div style="width: 10%">
        <el-select v-model="softwareTag" placeholder="软件标签" clearable>
          <el-option v-for="item in softwareTagList" :key="item.value" :label="item.name" :value="item.value" ></el-option>
        </el-select>
      </div>
      <div style="width: 100px;text-align: right;padding-right: 5px;">专业分类</div>
      <div style="width: 10%">
        <el-select v-model="professionalClassification" placeholder="专业分类" clearable>
          <el-option v-for="item in professionalClassificationList" :key="item.value" :label="item.name" :value="item.value" ></el-option>
        </el-select>
      </div>
      <div style="width: 100px;text-align: right;padding-right: 5px;">模糊匹配</div>
      <div style="width: 10%">
        <el-input v-model="fuzzyMatching"></el-input>
      </div>
      <div style="width: 8%;text-align: center;">
        <el-button  type="primary" @click="searchData" >搜索</el-button>
      </div>
      <div style="flex: 1;text-align: center">
        <el-button type="primary" @click="changeCardWidth">
          <i class="fa fa-th" aria-hidden="true" style="color: #FFFFFF;font-size: 20px"></i>
        </el-button>
      </div>

    </div>

    <splitpanes class="default-theme" style="height: calc(100% - 110px);">
<!----------------------------------------左侧树------------------------------------------------------------>
      <pane min-size="10" size="15" >
        <div style="height: 50px;line-height: 50px;background-color: white;">
          <el-select v-model="selectCatalog" style="padding-left: 5px;padding-right: 5px;" placeholder="目录查询" clearable
                     filterable remote :remote-method="getCatalogRemoteData" @change="setCatalog(selectCatalog)">
            <el-option v-for="item in catalogRemoteList" :key="item.id" :label="item.name" :value="item.id" ></el-option>
          </el-select>
        </div>

        <div class="card-header" style="width: 100%;border: solid 1px lightgrey">
          <span style="margin: 5px;font-weight: bold">工具目录</span>
          <el-icon :size="24" @click="refreshNode(currentDir.id)" style="margin-top: 5px">
            <ElIconRefresh class="el-icon-refresh"/>
          </el-icon>
        </div>

        <el-tree
            ref="tree"
            :data="dirData"
            :props="defaultProps"
            node-key="id"
            @node-click="nodeClickHandle"
            highlight-current
            :expand-on-click-node="false"
            style="height: calc(100% - 86px);overflow: auto"
        >
        </el-tree>
      </pane>
<!--------------------------------------------------右侧产品详情-------------------------------------------------->
      <pane min-size="50" style="background-color: white">
        <div style="background-color: white;display: flex;overflow: auto;flex-wrap: wrap;width: 100%;height: calc(100% - 35px)">

          <div class="list" v-for="product in productList" v-loading="loading" :style="cardWidth">

            <div class="software-card" style="margin: 10px;border-radius: 30px; background-color: #B5E3FF; width: calc(100% - 20px);height: calc(100% - 20px);">
              <div style="height: 15%;margin: 10px 10px 0 10px;display: flex;align-items: center;">
                <div style="width: 80%">
                  <el-image style="height: 30px" src="/icon/ds.png"></el-image>
                </div>
                <div style="width: 20%;display: flex; justify-content: center;">
                  <div style="width: 70%;height: 50%;background-color: #409eff;color: white;border-radius:5px;text-align: center;font-size: 10px;font-weight: bold">A2025</div>
                </div>

              </div>
              <div style="height: calc(85% - 26px);border-radius:20px;background-color: white;margin: 8px;overflow: hidden;font-size: 10px;">
                <el-tooltip :popper-style="{maxWidth: '600px', minWidth: '200px', width: 'auto'}"
                            :content="product.version_description"
                            :disabled="!product.shouldShowTooltip"
                            placement="top">
                <div class="multi-line-text" :id="'description_'+product.id">{{product.version_description}}</div>
                </el-tooltip>
                <div style="height: 13%;display: flex;align-items: center;">
                  <div style="width: 18%;text-align: right;font-weight: bold">软件编号：</div>
                  <div style="width: 82%">{{product.product_no}}</div>
                </div>
                <div style="height: 13%;display: flex;align-items: center;">
                  <div style="width: 18%;text-align: right;font-weight: bold">软件名称：</div>
                  <div style="width: 82%">{{product.product_name}}</div>
                </div>
                <div style="height: 13%;display: flex;align-items: center;">
                  <div style="width: 18%;text-align: right;font-weight: bold">软件标签：</div>
                  <div style="width: 82%;display: flex">
                    <div v-for="item in product.software_classification_names"
                         style="margin-right: 5px;text-align: center;width: 20%;background-color: #E5F5FF;
                         color: #30B0FF;font-size: 8px">{{ item }}</div>
                  </div>
                </div>
                <div style="height: 13%;display: flex;align-items: center;">
                  <div style="width: 18%;text-align: right;font-weight: bold">软件版本：</div>
                  <div style="width: 82%">{{product.version}}</div>
                </div>
                <div style="height: 13%;display: flex;align-items: center;">
                  <el-button type="primary" style="height: 50%;font-size: 10px;margin-left: 60%" @click="showDetail(product)">详情</el-button>
                  <el-button type="primary" style="height: 50%;font-size: 10px">下载</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="height:32px;display: flex;justify-content: flex-end;">
          <el-pagination background layout=" sizes, total, prev, pager, next,"
                         :page-sizes="[20,30,40]"
                         :current-page="currentPage"
                         v-model:page-size="pageSize"
                         :total="total"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :small="false"/>
        </div>
      </pane>

    </splitpanes>

  </div>
</template>

<script>

import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'


export default {
  name: "ToolWarehouseHomePage",
  components: {Splitpanes, Pane},

  data() {
    return {
      cardWidth:'width:32%',
      dirData: [],
      currentDir: {},
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      loading:false,
      pageSize:20,
      currentPage:1,
      total:0,
      productList:[],
      catalogRemoteList:[],
      selectCatalog:'',
      catalogList:[],
      softwareName:'',
      fuzzyMatching:'',
      softwareTag:'',
      professionalClassification:'',


    }
  },

  async created() {
    await this.loadDirTree();
  },

  computed: {
    softwareTagList() {
      return this.$store.getters['core/getDictList']('tool_software_tag');
    },
    professionalClassificationList() {
      return this.$store.getters['core/getDictList']('tool_professional_classification');
    },
  },

  methods: {

    refreshNode(nodeId){
      if(nodeId && nodeId.length > 0){
        this.$refs.tree.store.nodesMap[this.currentDir.id].loaded = false;
        this.$refs.tree.store.nodesMap[this.currentDir.id].loadData();
      }else{
        this.loadDirTree()
      }
    },

    //--勾选--
    async nodeClickHandle(currentRow) {
      this.currentDir = currentRow
      this.currentPage = 1
      let params = {
        dir_id: currentRow.id,
      }
      params.pageSize = this.pageSize;
      params.currentPage = this.currentPage;
      let data = await this.$http('toolWarehouseService.getProductByDirId',params);
      this.productList = data.productList;
      this.total = data.total;
    },

    async loadDirTree() {
      this.dirData = await this.$http('sysDirService.getDataSource(tool_warehouse)',{});
      await this.getCatalogList();
      await this.getAllToolProduct({});
      await this.setData();

    },

    async loadNode(node, resolve) {
      let data = await this.$http('sysDirService.getChildren', {dir_def_id: 'tool_warehouse', parent_id: node.data.id})
      resolve(data)
    },

    //搜索
    async searchData(){
      let data = {
        softwareName:this.softwareName,
        softwareTag:this.softwareTag,
        professionalClassification:this.professionalClassification,
        fuzzyMatching:this.fuzzyMatching,
      }
      data.pageSize = this.pageSize;
      data.currentPage = this.currentPage;
      await this.getAllToolProduct(data)

    },

    async setData(){
      for (let product of this.productList){
        product.constructor;
        // 检测多行文本是否溢出
        const element = document.getElementById('description_'+product.id);
        product.shouldShowTooltip = element.scrollHeight > element.clientHeight;
      }
    },

    //获取所有产品
    async getAllToolProduct(params){
      let data = await this.$http('toolWarehouseService.getToolProduct',params);
      this.total = data.total
      this.productList = data.productList;
    },
    //分页点击查询
    async handleSizeChange(val) {
      this.pageSize = val
      let params = {};
      params.pageSize = this.pageSize;
      params.currentPage = this.currentPage;
      await this.getAllToolProduct(params)
    },
    async handleCurrentChange(val) {
      this.currentPage = val
      let params = {};
      params.pageSize = this.pageSize;
      params.currentPage = this.currentPage;
      await this.getAllToolProduct(params)
    },

    //获取目录数据
    getCatalogList(){
      let remoteList = [];
      for (let item of this.dirData){
        let data = {...item};
        delete data.children;
        remoteList.push(data);
        if(item.children){
          this.findChildren(remoteList,item.children);
        }
      }
      this.catalogList = remoteList;
    },

    findChildren(remoteList,childrenList){
      for (let item of childrenList){
        let data = {...item};
        delete data.children;
        remoteList.push(data);
        if(item.children){
          this.findChildren(remoteList,item.children);
        }
      }
    },

    //获取目录remotes数据
    async getCatalogRemoteData(value){
      let list = [];
      if(value) {
        for (let item of this.catalogList) {
          if (item.name.includes(value)) {
            list.push(item);
          }
        }
      }
      this.catalogRemoteList = list;
    },

    //设置当前的节点
    setCatalog(catalogId){
      let currentNode = {};
      for (let item of this.catalogList){
        if(item.id === catalogId){
          currentNode = {...item};
          break;
        }
      }
      const tree = this.$refs.tree;
      const node = tree.getNode(currentNode);
      if (node) {
        // 展开所有父节点
        let parent = node.parent;
        while (parent && parent !== tree.root) {
          parent.expand();
          parent = parent.parent;
        }
        // 设置当前高亮节点
        tree.setCurrentKey(currentNode);
        // 滚动到节点
        this.$nextTick(() => {
          const el = node.$el;
          if (el) {
            el.scrollIntoView({behavior: 'smooth', block: 'nearest'});
          }
        });
      }
    },

    //打开详情页面
    showDetail(product){
      this.$store.dispatch('core/openWindow', {
        component: 'toolWarehouse/ProductDetail',
        parentData: product,
        name: '产品工具详情',
        max: true
      })

    },

    //调整卡片宽度
    changeCardWidth(){
      if(this.cardWidth === 'width:32%'){
        this.cardWidth = 'width:48%'
        return;
      }
      if(this.cardWidth === 'width:48%'){
        this.cardWidth = 'width:32%'
      }
    }


  },
}
</script>

<style lang="less" scoped>
@import '@/global.less';

.multi-line-text {
  height: 28%;
  margin-top: 10px;
  padding: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 18px; /* 需要明确行高 */
  -webkit-line-clamp: 4;
}


.software-card {
  /* 核心阴影配置 */
  box-shadow:
        0 -5px 7px -5px #B5E3FF,  /* 上边 */
        0 5px 7px -5px #B5E3FF,   /* 下边 */
        -5px 0 7px -5px #B5E3FF,  /* 左边 */
        5px 0 7px -5px #B5E3FF;   /* 右边 */

}

.myContainer {
  padding: 5px;
}

.dirButtons {
  display: inline-flex;
}

.card-header {
  display: inline-flex;
  height: 36px;
}

.department-name {
  font-size: @fontSizeX;
}


.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}


.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  margin-left: 5px;
  overflow: auto;
  height: 380px;
}

.list .list-item {
  width: 30%;
  min-height: 300px;
  /*  border: 1px solid red;*/
  margin-left: 20px;
  margin-bottom: 10px;
}



</style>